import { Component, OnDestroy, OnInit } from '@angular/core';
import { IHoverNotification } from '@models/hover-notification';
import { ToastService } from '@services/global/toast.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-hover-notification',
  templateUrl: './hover-notification.component.html'
})
export class HoverNotificationComponent implements OnInit, OnDestroy {
  public destroyed$ = new Subject();
  public notification: IHoverNotification;

  constructor(private readonly notifications: ToastService) {}

  ngOnInit() {
    this.notifications.displayInvalidationHoverMessage$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(notification => (this.notification = notification || null));
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
